// extracted by mini-css-extract-plugin
export var headerCell = "_5s-1";
export var loadingSpinnerContainer = "_5s-4";
export var loadingStateCell = "_5s-5";
export var rowWrapper = "_5s-3";
export var standaloneTable = "_5s-6";
export var table = "_5s-0";
export var white = "_5s-2";